import moment from 'moment'

export const getAllPlanDayFilter = (planDay: string) => {
  const today = planDay

  const yesterday = moment(planDay).subtract(1, 'days').toISOString()
  const tomorrow = moment(planDay).add(1, 'days').toISOString()
  const afterTomorrow = moment(planDay).add(2, 'days').toISOString()

  const start = 'duty_start_plan'
  const end = 'duty_end_plan'

  const firstIntervalFilter = `${start}=ge=${yesterday} and ${start}=lt=${today} and ${end}=ge=${today} and ${end}=lt=${tomorrow}`

  const lastIntervalFilter = `${start}=ge=${today} and ${start}=lt=${tomorrow} and ${end}=ge=${tomorrow} and ${end}=lt=${afterTomorrow}`

  const middleIntervalFilter = `${start}=ge=${today} and ${start}=lt=${tomorrow} and ${end}=ge=${today} and ${end}=lt=${tomorrow}`

  return `(${firstIntervalFilter}) or (${middleIntervalFilter}) or (${lastIntervalFilter})`
}
